import isEqual from 'lodash.isequal';
import { useRef } from 'react';
export const useDeepCompare = value => {
  const ref = useRef();
  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current ?? value;
};
//# sourceMappingURL=use-deep-compare.js.map